const status = {
  INITIALIZED: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3
}

const layouts = {
  DEFAULT_LAYOUT: 'default-layout',
  PAIGE_DASHBOARD: 'paige-dashboard',
  GROUP_ORDER_LAYOUT: 'group-order-layout',
  ADDRESS_COLLECTION: 'address-collection'
}

const orderStates = {
  PROCESSING: 'processing',
  CANCELED: 'canceled',
  UNPAID: 'unpaid'
}

const cardStates = {
  CARDS: 'CARDS',
  PERSONALIZED_CARD: 'Personalized Card',
  PERSONALIZED_CARDS: 'PERSONALIZED CARDS',
  PRINTED_CARD: 'Printed Card',
  PRINTED_CARDS: 'PRINTED CARDS',
  NO_CARD: 'no card',
  REDEMPTION: 'redemption'
}

const defaultNotFoundImage = require('./assets/gemnote-no-image_updated.png')
// 'https://s3-us-west-1.amazonaws.com/gemnote.com/gemnote-no-image.png'

const defaultNoTrendingImage = require('./assets/noun_image_trending.svg')
const defaultImageUploadPlaceholder = require('./assets/upload-placeholder.png')
const noBackground = require('./assets/redemmption-bg.png')
const brokenImage = require('./assets/broken-image.svg')

function ValidateEmail(mail) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailRegex.test(mail)
}

function validateZipCode(codeValue) {
  var zipCodePattern = /^\d{5}$|^\d{5}-\d{4}$/
  return zipCodePattern.test(codeValue)
}

function compare(a, b) {
  const createdAtA = a.createdAt
  const createdAtB = b.createdAt

  let comparison = 0
  if (createdAtA > createdAtB) {
    comparison = 1
  } else if (createdAtA < createdAtB) {
    comparison = -1
  }
  return comparison * -1
}

function compareInvoices(a, b) {
  const dateA = a.invoiceDate
  const dateB = b.invoiceDate

  let comparison = 0
  if (dateA > dateB) {
    comparison = 1
  } else if (dateA < dateB) {
    comparison = -1
  }
  return comparison * -1
}

function progressStatus(loadStatus) {
  switch (loadStatus) {
    case status.INITIALIZED:
    case status.LOADING:
      return false
    case status.LOADED:
    case status.ERROR:
      return true
  }
}

function isLoading(loadStatus) {
  switch (loadStatus) {
    case status.INITIALIZED:
      return false
    case status.LOADING:
      return true
    case status.LOADED:
    case status.ERROR:
      return false
  }
}

function onlyNumbersValidation(event) {
  let key = window.event ? event.which : event.keyCode
  if (key < 48 || key > 57) {
    event.preventDefault()
  }
}

const dummyTrending = [
  {
    id: Math.floor(Math.random() * 100),
    defaultImage: defaultNoTrendingImage,
    showBlur: true,
    product: {
      type: 'dummy'
    }
  },
  {
    id: Math.floor(Math.random() * 100),
    defaultImage: defaultNoTrendingImage,
    showBlur: true,
    product: {
      type: 'dummy'
    }
  },
  {
    id: Math.floor(Math.random() * 100),
    defaultImage: defaultNoTrendingImage,
    showBlur: true,
    product: {
      type: 'dummy'
    }
  },
  {
    id: Math.floor(Math.random() * 100),
    defaultImage: defaultNoTrendingImage,
    showBlur: true,
    product: {
      type: 'dummy'
    }
  }
]

let paymentMethodType = {
  CREDITCARD: 1,
  INVOICE: 2
}

const storeModules = {
  swag_store: 'swag_store',
  project: 'project',
  e_commerce: 'e_commerce'
}

function scrollPageToTop() {
  window.scrollTo(0, 0)
}

function capitalizeText(text) {
  return text.charAt(0).toUpperCase() + text.slice(1)
}

const userRoles = {
  TEAM_OWNER: 'team_owner',
  MEMBER: 'member',
  LIMITED_USER: 'limited_user',
  STORE_ADMIN: 'store_admin'
}

const recipientListFilterTypes = {
  Submitted: 'submitted',
  Pending: 'pending',
  Finalized: 'finalized',
  Skipped: 'skipped',
  All: 'all',
  NameOrEmail: 'NameOrEmail'
}

/**
 *
 * @param tagList array
 */
function isCard(tagList) {
  let transformedTagList = tagList.map(tag => tag.toLowerCase())
  return (
    transformedTagList.includes(cardStates.PERSONALIZED_CARD.toLowerCase()) ||
    transformedTagList.includes(cardStates.PERSONALIZED_CARDS.toLowerCase()) ||
    transformedTagList.includes(cardStates.PRINTED_CARD.toLowerCase()) ||
    transformedTagList.includes(cardStates.PRINTED_CARDS.toLowerCase())
  )
}

function isPrintedCard(tagList) {
  let transformedTagList = tagList.map(tag => tag.toLowerCase())
  return (
    transformedTagList.includes(cardStates.PRINTED_CARD.toLowerCase()) ||
    transformedTagList.includes(cardStates.PRINTED_CARDS.toLowerCase())
  )
}

function isPersonalizedCard(tagList) {
  let transformedTagList = tagList.map(tag => tag.toLowerCase())
  return (
    transformedTagList.includes(cardStates.PERSONALIZED_CARD.toLowerCase()) ||
    transformedTagList.includes(cardStates.PERSONALIZED_CARDS.toLowerCase())
  )
}

function handleBrokenImage(event) {
  const { target } = event
  target.src = brokenImage
  target.classList.add('broken-img')
}

/**
 * @param text string
 * @param length number
 */

function trimText(text, length = 20) {
  if (text && text.length > length) {
    return text.substring(0, length) + '...'
  }
  return text
}

function handleBundleOrderItems(orderItems) {
  const mergedArr = []
  const productVariantQuantities = {}

  orderItems.forEach(item => {
    const key = `${item.product_variant_id}-${item.bundle_id}`
    if (productVariantQuantities[key]) {
      productVariantQuantities[key].quantity += item.quantity
    } else {
      productVariantQuantities[key] = { ...item }
    }
  })

  for (const key in productVariantQuantities) {
    mergedArr.push(productVariantQuantities[key])
  }

  return mergedArr
}

const buildCartFromBag = shoppingBagProducts => {
  const cartItems = []
  shoppingBagProducts.forEach(product => {
    if (product.type === 'bundle') {
      product.items.forEach(item => {
        const existingItemIndex = cartItems.findIndex(
          ({ product_variant_id, bundle_id }) =>
            product_variant_id === parseInt(item.id) &&
            bundle_id === parseInt(product.bundle_id)
        )
        if (existingItemIndex !== -1) {
          cartItems[existingItemIndex].quantity += parseInt(
            product.quantity * item.quantity
          )
        } else {
          cartItems.push({
            product_variant_id: parseInt(item.id),
            quantity: parseInt(product.quantity * item.quantity),
            bundle_id: parseInt(product.bundle_id)
          })
        }
      })
    } else {
      cartItems.push({
        product_variant_id: parseInt(product.selectedVariant.id),
        quantity: parseInt(product.quantity),
        bundle_id: null
      })
    }
  })

  return cartItems
}

const extractEmailsFromCSV = csvContent => {
  const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g
  const matches = csvContent.match(emailRegex)
  return matches || []
}
const countRowsInCSV = async csvFile => {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader()

      reader.onload = event => {
        const cvsData = event.target.result

        const emails = extractEmailsFromCSV(cvsData)

        // const rowData = cvsData.split('\n')
        resolve(emails.length)
      }

      reader.readAsText(csvFile)
    } catch (error) {
      reject(error)
    }
  })
}

export {
  status,
  layouts,
  cardStates,
  ValidateEmail,
  validateZipCode,
  compare,
  compareInvoices,
  progressStatus,
  isLoading,
  orderStates,
  defaultNoTrendingImage,
  defaultNotFoundImage,
  onlyNumbersValidation,
  dummyTrending,
  paymentMethodType,
  storeModules,
  scrollPageToTop,
  capitalizeText,
  userRoles,
  recipientListFilterTypes,
  noBackground,
  defaultImageUploadPlaceholder,
  isCard,
  isPrintedCard,
  isPersonalizedCard,
  handleBrokenImage,
  trimText,
  handleBundleOrderItems,
  buildCartFromBag,
  countRowsInCSV
}
